import l, { useState as c } from "react";
import a from "./index277.mjs";
import r from "classnames";
const f = ({
  description: e
}) => {
  const [t, o] = c(!1), s = e ? e.length > 250 : !1, n = e && s && !t ? `${e.slice(0, 250)}...` : e;
  return /* @__PURE__ */ l.createElement(
    "div",
    {
      className: r(a.description, {
        [a.truncated]: s
      }),
      "data-testid": "extra-description"
    },
    n,
    s ? /* @__PURE__ */ l.createElement(
      "span",
      {
        onClick: () => o(!t),
        className: a.toggle
      },
      I18n.t(
        `booking_engine.information.${t ? "view_less" : "view_more"}`
      )
    ) : null
  );
};
export {
  f as ExtraDescription
};
